<template>
  <a-layout :class="['layout', device]">
    <!-- SideMenu -->
    <a-drawer
      v-if="isMobile()"
      placement="left"
      :wrapClassName="`drawer-sider ${navTheme}`"
      :closable="false"
      :visible="collapsed"
      @close="drawerClose"
    >
      <side-menu
        mode="inline"
        :menus="menus"
        :theme="navTheme"
        :collapsed="false"
        :collapsible="true"
        :width="logoWidth"
        @menuSelect="menuSelect"
        style="position: fixed; height: 100vh; overflow-y: auto"
      ></side-menu>
    </a-drawer>

    <side-menu
      v-else-if="isSideMenu()"
      mode="inline"
      :menus="menus"
      :theme="navTheme"
      :collapsed="collapsed"
      :collapsible="true"
      :width="logoWidth"
      @menuSelect="menuSelect"
      style="position: fixed; height: 100vh; overflow-y: auto"
    ></side-menu>
    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }"
    >
      <!-- layout header -->
      <div :style="{ position: 'fixed', right: '0', zIndex: '100', left: logoWidth, background: '#fff' }">
        <global-header
          :mode="layoutMode"
          :menus="menus"
          :theme="navTheme"
          :collapsed="collapsed"
          :device="device"
          @toggle="toggle"
        />
        <!-- <title-tab
          v-if="tabMenus"
          ref="titleTab"
          :select="select"
          :activekey="activekey"
          :pages="tabMenus"
          style="margin-top: 1px; padding: 10px 0px 0px 30px"
        ></title-tab> -->
      </div>

      <!-- layout content -->
      <a-layout-content
        :style="{
          height: '100%',
          margin: '0 0px 0',
          paddingTop: fixedHeader ? '64px' : '30px',
          padding: '0',
          background: '#fff',
          border: 'none',
        }"
      >
        <!-- <multi-tab v-if="multiTab"></multi-tab> -->
        <transition name="page-transition">
          <route-view />
        </transition>
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer>
        <global-footer />
      </a-layout-footer>

      <!-- Setting Drawer (show in development mode) -->
      <setting-drawer v-if="!production"></setting-drawer>
    </a-layout>
  </a-layout>
</template>

<script>
import { triggerWindowResizeEvent } from '@/utils/util'
import { mapState, mapActions, mapMutations } from 'vuex'
import { mixin, mixinDevice } from '@/utils/mixin'
import config from '@/config/defaultSettings'

import RouteView from './RouteView'
import SideMenu from '@/components/Menu/SideMenu'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import SettingDrawer from '@/components/SettingDrawer'
import TitleTab from '@/components/MultiTab/TitleTab'

export default {
  name: 'BasicLayout',
  mixins: [mixin, mixinDevice],
  components: {
    RouteView,
    SideMenu,
    GlobalHeader,
    GlobalFooter,
    SettingDrawer,
    TitleTab,
  },
  data() {
    return {
      production: config.production,
      collapsed: false,
      menus: [],
      select: false,
      tabMenus: [],
      activekey: '',
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: (state) => state.permission.addRouters,
    }),
    contentPaddingLeft() {
      if (this.fixSidebar || this.isMobile()) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '0'
      }
      return '0'
    },
    logoWidth() {
      if (this.fixSidebar || this.isMobile()) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '0'
      }
      return '0'
    },
  },
  watch: {
    sidebarOpened(val) {
      this.collapsed = !val
    },
  },
  created() {
    this.data = this.mainMenu.find((item) => item.path === '/').children
    this.menus = this.mainMenu.find((item) => item.path === '/').children
    this.collapsed = !this.sidebarOpened
    // this.getMenus(this.menus)
    // this.getTabMenus({ key: this.$route.path })
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }
  },
  methods: {
    ...mapActions(['setSidebar']),
    ...mapMutations('menuChildren', ['update']),
    toggle() {
      this.collapsed = !this.collapsed
      this.setSidebar(!this.collapsed)
      triggerWindowResizeEvent()
    },
    paddingCalc() {
      let left = ''
      if (this.sidebarOpened) {
        left = this.isDesktop() ? '206px' : '80px'
      } else {
        left = (this.isMobile() && '0') || (this.fixSidebar && '80px') || '0'
      }
      return left
    },
    menuSelect(obj) {
      this.getTabMenus(obj)
    },
    drawerClose() {
      this.collapsed = false
    },
    getMenus(menus) {
      for (const item of menus) {
        if (item.children) {
          for (const y of item.children) {
            y.chilData = y.children
            y.children = undefined
          }
          console.log(menus)
        }
      }
    },
    getTabMenus(obj) {
      this.tabMenus = []
      for (const i of this.data) {
        if (i.children) {
          for (const y of i.children) {
             if (y.path === obj.key && y.chilData) {
              for (const x of y.chilData) {
                  if (y.hidden !== true && x.hide !== true && x.hidden !== true) {
                    this.tabMenus.push(x)
                  }
              }
              this.select = true
              this.update({ childrenMenuPage: this.tabMenus })
              if (this.tabMenus.length > 0) {
                this.activekey = this.tabMenus[0].path
                this.$nextTick(() => {
                  this.$refs.titleTab.change(this.activekey)
                  this.update({ activekey: this.activekey })
                })
              }
            }
          }
        } else {
          if (i.path === obj.key) {
            this.tabMenus = []
          }
        }
      }
    },
  },
}
</script>

<style lang="less">
/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
